<template>
  <div>
    <router-link  to="/balance">
      <div  class="header-custom">
        <div>账号余额：{{this.formatPrice(allBalance)}}</div>
        <div><van-icon name="arrow" /></div>
      </div>
    </router-link>
<!--    <div v-if="!accountSetting.accountBalanceEnable && showTitle" class="header">-->
<!--      {{ $store.state.shop.name }}-->
<!--    </div>-->
  </div>
</template>

<script>
import Vue from 'vue';
import {Dialog, Toast} from 'vant';
import { getBalance } from '@/api/balance'
import Decimal from "decimal.js";


Vue.use(Dialog)

export default {
  name: 'balanceWithdraw',
  components: {
  },
  props: {
    showTitle: {
      type: Boolean,
      default:false
    }
  },
  model: {
  },
  data(){
    return{
      accountSetting: {},
      allBalance: 0
    }
  },
  mounted () {

  },

  methods:{
    getBalance() {
      Toast.loading({
        mask: true,
        message: '加载中...'
      })
      getBalance().then( res =>{
        Toast.clear()
        const data = res.data
        if(data.code == 0){
          this.balance = data.balance
          this.allBalance = data.balance + data.adminBalance + data.clerkBalance + data.kfBalance + data.leaderBalance
          this.accountSetting = data.accountSetting
        }else{
          Dialog.alert({
            title: '加载失败',
            message: data.msg
          })
        }
      })
    },
    formatPrice(price) {
      if (price != null) {
        return Decimal.div(price, 100).toString()
      }
      return ''
    }
  },
  activated() {
    this.getBalance()
  }
}
</script>

<style lang="less" scoped>
.header {
  position: relative;
  padding: 20px 15px;
  background: var(--primary-color);
  text-align: center;
  font-size: 22px;
  color: #fff;
  letter-spacing: 1px;
}
.header-custom{
  padding: 20px 10px;
  background: var(--primary-color);
  font-size: 16px;
  color: white;

  letter-spacing: 1px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

</style>

